import { useEffect, useState } from 'react';
/* eslint-disable */
import Tooltip from '@mui/material/Tooltip';

import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box } from '@mui/material';
import { checkTwoFactAuthApi, fetchBankListAPi } from 'utils/API/Merchant APIs/AepsApiCalls';
import { TwoFactAuthApi } from 'utils/API/Merchant APIs/UpdatedAPIs/AEPSUpdatedApiCall';
import { handleCatchError } from 'utils/CatchHandler';
import Autocomplete from '@mui/material/Autocomplete';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import BiometricDevices from 'views/Components/BiometricDevices/BiometricDevices';
import { useNavigate } from 'react-router-dom';
import AepsAuthCaptureModal from './AepsDailyAuthFinger';
import Spinner from 'views/Components/LoadingSinner';
const AadharMobileDialog = ({ open, handleClose }) => {
    const navigate = useNavigate();
    const [Aadhar, setAadhar] = useState('');
    const [Banks, setBanks] = useState([]);
    const [errorMsgAadhar, setErrorMsgAadhar] = useState('');
    const [bankValue, setBankValue] = useState('');
    const [selectedDeviceName, setSelectedDeviceName] = useState('');
    const [showDevices, setShowDevices] = useState(false);
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [retry, setRetry] = useState(false);
    const [location, setLocation] = useState({
        latitude: null,
        longitude: null
    });

    const loadingTexts = [
        'Fetching Aadhaar details...',
        'Verifying identity...',
        'Validating document information...',
        'Connecting to UIDAI servers...',
        'Securing your data...',
        'Decrypting Aadhaar response...',
        'Finalizing authentication...'
    ];
    const handleDeviceSelect = (deviceName) => {
        setSelectedDeviceName(deviceName);
        setShowAuthModal(true);
    };

    const onCaptureSuccess = (data) => {
        setShowAuthModal(false);
        globalNotifySuccess('Fingerprint captured successfully!');
        if (data) {
            fetchDailyAuth(data);
        }
    };

    const onCaptureFailure = () => {
        setShowAuthModal(true);
        setRetry(true);
    };

    useEffect(() => {
        const BankList = async () => {
            try {
                const response = await fetchBankListAPi();
                const datas = response?.data;
                const BankData = datas?.data;
                setBanks(BankData);
            } catch (error) {
                console.log(error.message);
                handleCatchError(error);
            }
        };
        BankList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchDailyAuth = async (data) => {
        const type = 'AEPS';
        // const agent_id = localStorage.getItem('user_id');
        // const agent_id = "2";
        // const agentId = '2146f726-d0b7-42d9-9822-861c5307a8b6';
        // const agentId = '2146f726-d0b7-42d9-9822-861c5307a8b6';
        const nationalBankIdentification = bankValue?.iinno;
        const aadhaarNo = Aadhar;
        // const latitude = location?.latitude?.toString();
        // const longitude = location?.longitude?.toString();
        // const beta = true;
        setIsLoading(true);
        try {
            const payload = {
                // agentId,
                nationalBankIdentification,
                aadhaarNo,
                data,
                // latitude,
                // longitude,
                type
            };

            const response = await TwoFactAuthApi(payload);

            const resData = response?.response?.data?.message || response?.data?.message;

            setIsLoading(false);
            if (response.status) {
                globalNotifySuccess(response?.data?.message);
                handleClose();
            } else {
                setRetry(true);
                globalNotifyError(resData);
            }
        } catch (error) {
            setIsLoading(false);
            handleCatchError(error);
            console.log(error.message);
        }
    };

    //geo location function
    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            },
            (error) => {
                console.error(error);
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = () => {
        setShowDevices(true);
    };
    function handleBankChange(event, newValue) {
        setBankValue(newValue);
    }
    const validateAadhar = () => {
        const re = /^[0-9]{12}$/; // Regular expression to match 10 digit mobile number
        if (!re.test(Aadhar)) {
            setErrorMsgAadhar('Please enter a valid 12 digit Aadhar number');
        } else {
            setErrorMsgAadhar('');
        }
    };

    const handleAadharChange = (e) => {
        let amountValue = e.target.value.replace(/[^\d.]/g, '');
        amountValue = amountValue.slice(0, 12);
        setAadhar(amountValue);
    };

    const handleBack = () => {
        navigate('/merchant-home');
    };

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    onClose();
                }
            }}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>Daily Authentication</DialogTitle>
            <DialogContent>
                <Box mt={2}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        value={bankValue ? bankValue : null}
                        options={Banks ? Banks : ''}
                        onChange={handleBankChange}
                        getOptionLabel={(option) => (option?.bankName ? option?.bankName : '')}
                        sx={{ width: '100%', mb: 1 }}
                        renderInput={(params) => <TextField {...params} label="Select Bank *" />}
                    />
                    <TextField
                        id="outlined-basic"
                        label="Aadhaar Number"
                        variant="outlined"
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                        value={Aadhar}
                        helperText={errorMsgAadhar}
                        error={Boolean(errorMsgAadhar)}
                        onChange={handleAadharChange}
                        onBlur={validateAadhar}
                    />
                    {selectedDeviceName && (
                        <Box sx={{ color: 'text.secondary', fontSize: '14px', mt: 1 }}>
                            Selected Device: <strong>{selectedDeviceName}</strong>
                        </Box>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleBack} color="secondary">
                    Cancel
                </Button>
                {retry ? (
                    <Tooltip title={!Aadhar || !bankValue ? 'Please enter Aadhaar and select a bank' : ''} arrow placement="top">
                        <span>
                            <Button
                                variant="contained"
                                color="error"
                                disabled={!Aadhar || !bankValue}
                                onClick={() => {
                                    setShowAuthModal(true);
                                }}
                            >
                                Retry
                            </Button>
                        </span>
                    </Tooltip>
                ) : (
                    <Tooltip title={!Aadhar || !bankValue ? 'Please enter Aadhaar and select a bank' : ''} arrow placement="top">
                        <span>
                            <Button
                                onClick={handleSubmit}
                                disabled={!Aadhar || !bankValue}
                                style={{
                                    background: 'linear-gradient(135deg, rgb(25, 26, 27), #1976D2)',
                                    color: '#ffffff'
                                }}
                            >
                                Submit
                            </Button>
                        </span>
                    </Tooltip>
                )}
            </DialogActions>
            {showDevices && <BiometricDevices onDeviceSelect={handleDeviceSelect} />}
            {showAuthModal && selectedDeviceName && (
                <AepsAuthCaptureModal
                    open={showAuthModal}
                    deviceName={selectedDeviceName}
                    onClose={() => {
                        setShowAuthModal(false);
                        setRetry(true);
                    }}
                    onCaptureSuccess={onCaptureSuccess}
                    onCaptureFailure={onCaptureFailure}
                />
            )}
            <Spinner loading={isLoading} texts={loadingTexts} />
        </Dialog>
    );
};

export default AadharMobileDialog;
